/** Must match `roles.name` in API migrations (Parceiro Master / Parceiro Equipe). */
export const PARTNER_MASTER_ROLE_NAME = "Parceiro Master";
export const PARTNER_TEAM_ROLE_NAME = "Parceiro Equipe";

export function isPartnerMasterRole(
  roles?: { name: string }[] | null
): boolean {
  return roles?.some((r) => r.name === PARTNER_MASTER_ROLE_NAME) ?? false;
}

export function isPartnerPortalRoleName(name: string): boolean {
  return (
    name === PARTNER_MASTER_ROLE_NAME || name === PARTNER_TEAM_ROLE_NAME
  );
}

export function hasPartnerPortalAccess(
  roles?: { name: string }[] | null
): boolean {
  if (!roles?.length) return false;
  return roles.some((r) => isPartnerPortalRoleName(r.name));
}
